import NotFound from './NotFound.jsx';
import './NotFound.scss';

export default NotFound;
